// TODO(keep): Refactored file to keep
import { queryOptions } from '@tanstack/react-query'

import { staleTime } from '@/shared/constants/stale-time'
import { PaginationQueryParams } from '@/shared/schemas/pagination'

import { eligibleRoleApi } from './api'

export const eligibleRoleGetAllQueryOptions = () =>
  queryOptions({
    queryFn: () => eligibleRoleApi.getAll(),
    queryKey: ['eligibleRole', 'getAll'],
    staleTime: staleTime.ONE_DAY,
  })

export const eligibleRoleSearchByNameQueryOptions = (query: string) =>
  queryOptions({
    enabled: !!query,
    queryFn: () => eligibleRoleApi.searchByName(query),
    queryKey: ['eligibleRole', 'searchByName', query],
    staleTime: staleTime.ONE_MINUTE,
  })

export const eligibleRoleByIdQueryOptions = (id: string, filters: PaginationQueryParams) =>
  queryOptions({
    queryFn: () => eligibleRoleApi.getById(id, filters),
    queryKey: ['eligibleRole', id, filters],
    staleTime: staleTime.ONE_MINUTE,
  })
